import { jsxs, jsx } from "react/jsx-runtime";
import { SupportTicketCard } from "../../../components/ConciergeMessagePart/SupportTicketCard.js";
const TicketCardWidget = ({ data }) => {
  const { ticketId, displayId, status, sla, priority, ticketUrl, message, nextSteps } = data;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        width: "100%",
        maxWidth: 420,
        padding: "4px 0",
        boxSizing: "border-box"
      },
      children: [
        priority === "high" && /* @__PURE__ */ jsxs(
          "div",
          {
            style: {
              display: "inline-flex",
              alignItems: "center",
              gap: 5,
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: 0.4,
              textTransform: "uppercase",
              color: "var(--voice-widget-warn, #DC2626)",
              background: "var(--voice-widget-warn-bg, #FEF2F2)",
              border: "1px solid var(--voice-widget-warn-border, #FECACA)",
              padding: "3px 10px",
              borderRadius: 999,
              marginBottom: 8
            },
            children: [
              /* @__PURE__ */ jsx("span", { children: "●" }),
              " High priority"
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "div",
          {
            style: {
              fontSize: 12,
              color: "var(--voice-widget-muted, #6B7280)",
              marginBottom: 6
            },
            children: [
              "Response within ",
              /* @__PURE__ */ jsx("strong", { style: { color: "var(--voice-widget-fg, #111827)" }, children: sla })
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          SupportTicketCard,
          {
            status: "success",
            message: message ?? "",
            ticketId,
            displayId,
            ticketUrl,
            ticketState: status,
            nextSteps
          }
        )
      ]
    }
  );
};
export {
  TicketCardWidget
};
//# sourceMappingURL=TicketCardWidget.js.map
